import { FunctionComponent } from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Label } from 'src/shared';
import { tableStyles } from '../CommunityContributors/styled';
import { IContributorBreakdown } from 'src/types/community';
import BillableHoursRatio from 'src/shared/BillableHoursRatio';
import AvailabilityCell from './AvailabilityCell';

export interface Props {
    row: IContributorBreakdown;
}

const ContributorRow: FunctionComponent<Props> = ({ row }: Props) => {
    return (
        <TableRow sx={tableStyles.dataRow}>
            <TableCell
                sx={{
                    ...tableStyles.muiTableCell,
                    ...tableStyles.headCellMdPlus,
                    ...tableStyles.dataCellPadding,
                    ...tableStyles.underline
                }}
            >
                <Label
                    component="span"
                    sxOverrides={{
                        ...tableStyles.dataLabel,
                        ...tableStyles.dataCell
                    }}
                >
                    {row.name}
                </Label>
            </TableCell>
            <TableCell
                sx={{
                    ...tableStyles.muiTableCell,
                    ...tableStyles.dataCellPadding,
                    ...tableStyles.headCellXsPlus,
                    ...tableStyles.statusCell
                }}
            >
                <AvailabilityCell
                    userId={row.id}
                    status={row.status}
                    lastStatusUpdated={row.lastStatusUpdated}
                />
            </TableCell>
            <TableCell
                sx={{
                    ...tableStyles.muiTableCell,
                    ...tableStyles.headCellMd,
                    ...tableStyles.dataCellPadding
                }}
            >
                <Label
                    component="span"
                    sxOverrides={{
                        ...tableStyles.dataLabel,
                        ...tableStyles.dataCell
                    }}
                >
                    {row.lastEngagement}
                </Label>
            </TableCell>
            <TableCell
                sx={{
                    ...tableStyles.muiTableCell,
                    ...tableStyles.headCellXsPlus,
                    ...tableStyles.dataCellPadding
                }}
            >
                <Label
                    component="span"
                    sxOverrides={{
                        ...tableStyles.dataLabel,
                        ...tableStyles.dataCell
                    }}
                >
                    {row.reservedWorks}
                </Label>
            </TableCell>
            <TableCell
                sx={{
                    ...tableStyles.muiTableCell,
                    ...tableStyles.headCellMd,
                    ...tableStyles.dataCellPadding
                }}
            >
                <Label
                    component="span"
                    sxOverrides={{
                        ...tableStyles.dataLabel,
                        ...tableStyles.dataCell
                    }}
                >
                    <BillableHoursRatio ratio={row.billableHoursRatio / 100} />
                </Label>
            </TableCell>
            <TableCell
                sx={{
                    ...tableStyles.muiTableCell,
                    ...tableStyles.headCellXs,
                    ...tableStyles.dataCellPadding
                }}
            >
                <Label
                    component="span"
                    sxOverrides={{
                        ...tableStyles.dataLabel,
                        ...tableStyles.dataCell
                    }}
                >
                    {'$' + row.hourlyRate}
                </Label>
            </TableCell>
            <TableCell
                sx={{
                    ...tableStyles.muiTableCell,
                    ...tableStyles.headCellXlPlus,
                    ...tableStyles.dataCellPadding
                }}
            >
                <Label
                    component="span"
                    sxOverrides={{
                        ...tableStyles.dataLabel,
                        ...tableStyles.dataCell
                    }}
                >
                    {row.projects.join(', ')}
                </Label>
            </TableCell>
        </TableRow>
    );
};

export default ContributorRow;
